<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <v-card class='elevation-2 animated fadeIn'>
                    <v-toolbar flat>
                        <v-toolbar-title>Manejo de Certificaciones</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row>
                            <v-btn color="warning" v-on:click="downloadReportProgreso"><v-icon>cloud_download</v-icon>&nbsp;Progreso</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" v-on:click="getAllSchools"><v-icon>refresh</v-icon> Refrescar</v-btn>
                        </v-layout>
                        <v-text-field v-model="searchSchools"
                                      append-icon="search"
                                      label="Buscar"
                                      single-line
                                      hide-details></v-text-field>
                        <v-data-table :headers="schoolsHeaders"
                                      :items="schools"
                                      :search="searchSchools"
                                      :loading="schoolsLoading"
                                      no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                      rows-per-page-text="Filas por página"
                                      :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                      class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td>{{ props.item.REGION_NAME }}</td>
                                <td class="text-xs-left">{{ props.item.SCHOOL_NAME }}</td>
                                <td class="text-xs-left">{{ props.item.SCHOOL_CODE }}</td>
                                <td class="text-xs-center">
                                    <v-btn v-if="props.item.GRADUATION_PERIOD_ID_FK == 1" color="error" small fab v-on:click="deleteSchoolCertification(props)"><v-icon>delete</v-icon></v-btn>
                                </td>
                                <td class="text-xs-center">
                                    <v-btn v-if="props.item.GRADUATION_PERIOD_ID_FK == 2" color="error" small fab v-on:click="deleteSchoolCertification(props)"><v-icon>delete</v-icon></v-btn>
                                </td>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                Su búsqueda por "{{ searchSchools }}" no encontro resultados.
                            </v-alert>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import script from './script'
    export default script
</script>


// WEBPACK FOOTER //
// src/components/graduados/certificaciones/component.vue